/**
 * Auto-generated by scripts/sync-flashback-env.js from .env — do not edit by hand.
 * Regenerate: `npm start`, `npm run build`, or `node scripts/sync-flashback-env.js`.
 */
export const API_BASE_URL = "https://api.dev.nvr.construction.digitaleye.ai";
export const FLASHBACK_DUMMY_VIDEO = false;
export const FLASHBACK_DUMMY_VIDEO_URL = "";
